/**
 *  @class
 *  @function CartUpsell
 *
 *  Adds an upsell product to the cart via AJAX and refreshes the cart page,
 *  cart drawer and cart bubble in place. The upsell list itself lives inside
 *  the re-rendered cart/drawer sections, so the just-added product disappears
 *  from the list automatically after the refresh.
 */
if (!customElements.get('cart-upsell')) {
  class CartUpsell extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const button = event.target.closest('.cart-upsell__item-add[data-variant-id]');
      if (!button) return;

      event.preventDefault();
      this.addToCart(button);
    }

    addToCart(button) {
      if (button.classList.contains('loading')) return;

      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');

      const formData = new FormData();
      formData.append('id', button.dataset.variantId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'cart-upsell',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id) || !parsedState.sections[section.section]) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return parsed ? parsed.innerHTML : '';
    }
  }

  customElements.define('cart-upsell', CartUpsell);
}
